import React from "react";
import { RiDeleteBin7Line } from "react-icons/ri";
import { SlPencil } from "react-icons/sl";
import deleteModel from "../components/SweetAlert";
import { FiEye } from "react-icons/fi";

const ActionButtons = ({
  handleEdit,
  handleDelete,
  handleView,
  id,
  data,
  hideEdit,
  showView,
  extraMesg
}) => {
  return (
    <div className="d-flex gap-2">
      {!hideEdit && (
        <button
          className="edit"
          onClick={() => {
            handleEdit(data);
          }}
        >
          <SlPencil size={18} />
          Edit
        </button>
      )}
      {showView && (
        <button className="view" onClick={() => handleView(data, data?._id)}>
          <FiEye size={18} />
          View
        </button>
      )}
      <button
        className="delete"
        onClick={() => {
          deleteModel(handleDelete, data?._id, extraMesg);
        }}
      >
        <RiDeleteBin7Line size={18} />
        Delete
      </button>
    </div>
  );
};

export default ActionButtons;
